import { combineReducers } from "redux";
import {
	alerts,
	applications,
	applicationsForm,
	authorization,
	currentTheme,
	notifications,
	profile,
	tickets,
	ticketsForm,
	users,
	usersForm,
} from "./Reducers";

export default combineReducers({
	alerts,
	applications,
	applicationsForm,
	authorization,
	currentTheme,
	notifications,
	profile,
	tickets,
	ticketsForm,
	users,
	usersForm,
});
